/* Public Site Check walk overlay — mounts the SHARED React RecorderSession
   on the anonymous landing page, replacing the old Jinja _recorder_modal.html.

   Built as a standalone fixed-name IIFE (vite.config.public-recorder.js) that
   bundles React + RecorderSession, and exposes:

     window.ContextaRecorder.start(session)

   landing.html / landing_walk.html call this with the JSON returned by
   POST /recorder/cloud-record/start. No onDone is passed, so RecorderSession
   falls back to redirecting to the server report_url_template from /finish
   (the public /site-check/scan/<check_id>/report). */
import { createRoot } from 'react-dom/client';
import RecorderSession from './RecorderSession.jsx';

const HOST_ID = 'contexta-recorder-root';

function start(session, opts = {}) {
  if (!session || !session.status_url) return;

  // Tear down any previous mount first.
  const prev = document.getElementById(HOST_ID);
  if (prev) {
    if (prev.__ctxRoot) { try { prev.__ctxRoot.unmount(); } catch (_) {} }
    prev.remove();
  }

  const host = document.createElement('div');
  host.id = HOST_ID;
  document.body.appendChild(host);
  const root = createRoot(host);
  host.__ctxRoot = root;

  const close = () => {
    try { root.unmount(); } catch (_) {}
    try { host.remove(); } catch (_) {}
    if (typeof opts.onClose === 'function') opts.onClose();
  };

  root.render(<RecorderSession session={session} onClose={close} />);
}

window.ContextaRecorder = { start };
